<script setup>
import DxTagBox from 'devextreme-vue/tag-box'
import { textColor, stringToColor } from '@/lib/utils'

const props = defineProps({
  value: {
    type: [Array, null],
    required: false,
    default: null,
  },
  dataSource: {
    type: Array,
    required: true,
  },
  acceptCustomValue: {
    type: Boolean,
    default: true,
  },
  allowMultiple: {
    type: Boolean,
    default: true,
  },
  hideSelectedItem: {
    type: Boolean,
    default: true,
  }
})

const onValueChanged = (e) => {
  if (!props.allowMultiple) {
    if (e.value.length > 1) {
      e.value = [e.value[1]] // Limit to the first item if multiple are selected
    }
  }
  emits('value-changed', e)
}

const emits = defineEmits(['custom-item-creating', 'value-changed', 'initialized'])

const getStyleForTag = (tagName) => {
  const color = stringToColor(tagName)
  return {
    backgroundColor: color,
    color: textColor(color)
  }
}

</script>
<template>
  <dx-tag-box
    :value="props.value"
    :data-source="props.dataSource"
    tag-template="tag-template"
    item-template="item-template"
    value-expr="id"
    display-expr="name"
    use-input
    multiple
    :search-enabled="true"
    :hide-selected-items="props.hideSelectedItem"
    :accept-custom-value="props.acceptCustomValue"
    @initialized="emits('initialized', $event)"
    @custom-item-creating="emits('custom-item-creating', $event)"
    @value-changed="onValueChanged"
  >
    <template #tag-template="{ data: innerData }">
      <div
        class="dx-tag-content"
        :style="getStyleForTag(innerData.name)"
      >
        <div class="dx-tag-remove-button" />
        <div class="dx-tag-text">
          {{ innerData.name }}
        </div>
      </div>
    </template>
    <template #item-template="{ data: innerData }">
      <div
        class="dx-tag-content"
        :style="{ ...getStyleForTag(innerData.name), width: 'auto', margin: '0.4rem', padding: '.125rem .5rem' }"
      >
        <div class="dx-tag-text">
          {{ innerData.name }}
        </div>
      </div>
    </template>
  </dx-tag-box>
</template>

<style>
</style>
